import React from 'react';
import withOnlyAtlassianAccount from 'view/common/with-only-atlassian-account';
import { withOnlyLoggedIn } from 'view/common/with-only-logged-in';
import { compose } from 'redux';
import {
    ADD_HELP_CONTENT_PATH,
    ADD_HELP_DESK_PATH,
    EDIT_HELP_DESK_PATH,
    ScreenName,
    AddContentTypes,
    VIEW_HELP_DESK_PATH,
} from 'view/common/constants';
import AddHelpDeskPage from 'view/help-desk/add-help-desk-page/add-help-desk-page';
import { EditHelpDeskPage } from 'view/help-desk/edit-help-desk-page';
import { AddHelpContentPage } from 'view/help-desk/add-help-content';
import HomePage from 'view/unified-help-center';
import TestHarness from 'view/unified-help-center/test-harness';
import ConversationsLog from 'view/unified-help-center/conversations-log';
import Layout from 'view/unified-help-center/layout';
import { ErrorPage } from 'view/unified-help-center/error-page';
import type { RouteContext } from 'react-resource-router';
import { ViewHelpDeskPage } from 'view/help-desk/view-help-desk-page';

const Error = () => <ErrorPage />;

const UnifiedHelpHomePage = () => {
    const WrappedComponent = compose(
        withOnlyLoggedIn({ redirectUrl: '/' }),
        withOnlyAtlassianAccount()
    )(() => <Layout renderError={Error} component={HomePage} screenName={ScreenName.UNIFIED_HELP_HOME_PAGE} />);
    return <WrappedComponent />;
};

const UnifiedHelpConversationsLog = () => {
    const WrappedComponent = compose(
        withOnlyLoggedIn({ redirectUrl: '/' }),
        withOnlyAtlassianAccount()
    )(() => (
        <Layout
            component={ConversationsLog}
            screenName={ScreenName.UNIFIED_HELP_CONVERSATIONS_LOG}
            renderError={Error}
        />
    ));
    return <WrappedComponent />;
};

const UnifiedHelpTestHarness = () => {
    const WrappedComponent = compose(
        withOnlyLoggedIn({ redirectUrl: '/' }),
        withOnlyAtlassianAccount()
    )(() => <Layout component={TestHarness} screenName={ScreenName.UNIFIED_HELP_TEST_HARNESS} renderError={Error} />);
    return <WrappedComponent />;
};

const AddHelpContentPageLayout = (props: RouteContext) => {
    const { contentType } = props.match.params;

    let screenName = ScreenName.ADD_HELP_CONTENT_EXTERNAL_LINKS;
    if (contentType === AddContentTypes.KNOWLEDGE_RESOURCE) {
        screenName = ScreenName.ADD_HELP_CONTENT_KNOWLEDGE_RESOURCES;
    }

    const WrappedComponent = compose(
        withOnlyLoggedIn({
            redirectUrl: props.location.pathname,
        }),
        withOnlyAtlassianAccount()
    )(() => <Layout component={AddHelpContentPage} screenName={screenName} />);
    return <WrappedComponent {...props} />;
};

const AddHelpDeskPageLayout = (props: RouteContext) => {
    const WrappedComponent = compose(
        withOnlyLoggedIn({
            redirectUrl: props.location.pathname,
        }),
        withOnlyAtlassianAccount()
    )(() => <Layout component={AddHelpDeskPage} screenName={ScreenName.ADD_HELP_DESK} />);
    return <WrappedComponent {...props} />;
};

const ViewHelpDeskPageLayout = (props: RouteContext) => {
    const WrappedComponent = compose(
        withOnlyLoggedIn({ redirectUrl: props.location.pathname }),
        withOnlyAtlassianAccount()
    )(() => <Layout renderError={Error} component={ViewHelpDeskPage} screenName={ScreenName.VIEW_HELP_DESK} />);
    return <WrappedComponent />;
};

const EditHelpDeskPageLayout = (props: RouteContext) => {
    const WrappedComponent = compose(
        withOnlyLoggedIn({
            redirectUrl: props.location.pathname,
        }),
        withOnlyAtlassianAccount()
    )(() => <Layout component={EditHelpDeskPage} screenName={ScreenName.EDIT_HELP_DESK} />);
    return <WrappedComponent {...props} />;
};

export const viewUnifiedHelpHomePageRoute = {
    name: ScreenName.UNIFIED_HELP_HOME_PAGE,
    path: '/',
    exact: true,
    component: UnifiedHelpHomePage,
};

export const viewUnifiedHelpTestPageRoute = {
    name: 'unified-help-test',
    path: '/test',
    exact: true,
    component: UnifiedHelpTestHarness,
};

// export const manageUnifiedHelpHomePageRoute = {
//     name: 'manage',
//     path: '/manage',
//     exact: true,
//     component: UnifiedHelpHomePage,
// };

export const unifiedHelpConversationsStore = {
    name: 'chats',
    path: '/chats',
    exact: true,
    component: UnifiedHelpConversationsLog,
};

export const addHelpDeskRoute = {
    name: ScreenName.ADD_HELP_DESK,
    path: ADD_HELP_DESK_PATH,
    exact: true,
    component: AddHelpDeskPageLayout,
};

export const editHelpDeskRoute = {
    name: ScreenName.EDIT_HELP_DESK,
    path: EDIT_HELP_DESK_PATH,
    exact: true,
    component: EditHelpDeskPageLayout,
};

export const viewHelpDeskRoute = {
    name: ScreenName.VIEW_HELP_DESK,
    path: VIEW_HELP_DESK_PATH,
    exact: true,
    component: ViewHelpDeskPageLayout,
};

export const addHelpContentRoute = {
    name: ScreenName.ADD_HELP_CONTENT,
    path: ADD_HELP_CONTENT_PATH,
    component: AddHelpContentPageLayout,
};
